import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { ADMIN_ROUTE_PATHS } from '@oneComply/core/constants/admin-route-paths';
import { ProfileService } from '@oneComply/core/services/profile.service';

export const companyAdminGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  return profileService.getMe().pipe(
    map((response) => {
      if (response.data.role === 'admin') {
        return true;
      }

      return router.createUrlTree([ADMIN_ROUTE_PATHS.accessDenied]);
    }),
    catchError(() => of(router.createUrlTree([ADMIN_ROUTE_PATHS.accessDenied]))),
  );
};
